<cap-content-header>
  <cap-title>
    {{ "gemeinde.SucheTitel" | translate }}
  </cap-title>
</cap-content-header>

<form (ngSubmit)="onSubmit()" [meta]="gemeinde" #form="ngForm" class="mt-2">
  <cap-form-row>
    <cap-form-control column-classes="col-md-2,col-md-2" labelKey="gemeinde.name">
      <input
        (ngModelChange)="gemeinde && (gemeinde.name = $event)"
        [ngModel]="gemeinde && gemeinde.name"
        #gemeinde.name
        appAutofocus
        name="gemeinde.name"
        type="text" />
    </cap-form-control>
  </cap-form-row>
  <cap-form-row>
    <cap-form-control column-classes="col-md-2,col-md-2" invalidKey="EingabeMussValideNummerSeinBeispiel" labelKey="gemeinde.bfs">
      <input (ngModelChange)="gemeinde && (gemeinde.bfs = $event)" [ngModel]="gemeinde && gemeinde.bfs" name="gemeinde.bfs" type="text" />
    </cap-form-control>
  </cap-form-row>
  <cap-form-row>
    <cap-form-control column-classes="col-md-2,col-md-2" invalidKey="EingabeMussValideNummerSeinBeispiel" labelKey="gemeinde.kreis">
      <input
        (ngModelChange)="gemeinde && (gemeinde.kreis = $event)"
        [ngModel]="gemeinde && gemeinde.kreis"
        name="gemeinde.kreis"
        type="text" />
    </cap-form-control>
  </cap-form-row>
  <div class="p-2" id="actionpane">
    <div class="rechtsbuendig">
      <button (click)="onReset()" class="btn btn-outline-primary btn-actionpane" type="button">{{ "Zurücksetzen" | translate }}</button>
      <button [disabled]="!form.form.valid || !gemeinde" class="btn btn-primary btn-actionpane" type="submit">
        {{ "Suche" | translate }}
      </button>
    </div>
  </div>
</form>
